module.exports = __webpack_public_path__ + "img/1001-Ansichten.a59fb03a.jpg";